import { ArrowLeft } from 'lucide-react';
import type { ReactNode } from 'react';

import { Button } from '@/components/Button/Button';

import styles from './GradebookHeader.module.css';

interface GradebookHeaderProps {
  actions?: ReactNode;
  backLabel: string;
  onBack: () => void;
  subtitle?: string;
  title: string;
}

export function GradebookHeader({
  actions,
  backLabel,
  onBack,
  subtitle,
  title,
}: GradebookHeaderProps) {
  return (
    <header className={styles.header}>
      <Button className={styles.backButton} onClick={onBack} variant="ghost">
        <ArrowLeft aria-hidden="true" size={16} strokeWidth={2} />
        {backLabel}
      </Button>
      <div className={styles.titleRow}>
        <div className={styles.copy}>
          <h1 className={styles.title}>{title}</h1>
          {subtitle ? <p className={styles.subtitle}>{subtitle}</p> : null}
        </div>
        {actions ? <div className={styles.actions}>{actions}</div> : null}
      </div>
    </header>
  );
}
